import { handleEmit } from ".";
import { getCurrentContractAddresses } from "../../configs/address";
import ABI from "src/contract-logic/abis/VeTravaMarketplaceABI.json";
import { getWeb3Sender, web3Reader } from "../../wallet-connection";
import BigNumber from "bignumber.js";
import { BASE18 } from "src/configs/constance";

const { VE_TRAVA_MARKETPLACE_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) contractReader = new web3Reader.eth.Contract(ABI, VE_TRAVA_MARKETPLACE_ADDRESS);
  if (!contractReader) throw new Error("Failed to create contract reader");
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) contractSender = new web3Sender.eth.Contract(ABI, VE_TRAVA_MARKETPLACE_ADDRESS);
  if (!contractSender) throw new Error("Failed to create contract sender");
  return contractSender;
}
async function getTokenOrder(tokenId) {
  const res = await getContractReader().methods.getTokenOrder(tokenId).call();
  return {
    price: BigNumber(res.price.toString()).dividedBy(BASE18).toNumber(),
    seller: res.nftSeller,
    paymentOption: BigNumber(res.paymentOption.toString()).toNumber(),
  };
}
async function getTokenOfOwnerBalance(ownerAddr) {
  const res = await getContractReader().methods.getTokenOfOwnerBalance(ownerAddr).call();
  return parseInt(res);
}

async function createSale(dispatch, tokenId, price, option, ownerAddr) {
  const emit = getContractSender().methods.createSale(tokenId, price, option).send({ from: ownerAddr });
  handleEmit(dispatch, emit, "Create Sale");
  await emit;
}
async function makeSaleOrder(dispatch, tokenId, accountAddress) {
  const emit = getContractSender().methods.makeOrder(tokenId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Buy veTrava");
  return await emit;
}
async function getTokenOnSaleCount() {
  const res = await getContractReader().methods.getTokenOnSaleCount().call();
  return parseInt(res);
}
async function cancelSale(dispatch, tokenId, accountAddress) {
  const emit = getContractSender().methods.cancelSale(tokenId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Cancel Sell VeTrava");
  return await emit;
}

export default {
  ABI,
  ADDRESS: VE_TRAVA_MARKETPLACE_ADDRESS,
  createSale,
  getTokenOnSaleCount,
  getTokenOrder,
  makeSaleOrder,
  getTokenOfOwnerBalance,
  cancelSale,
};
